// Productos no stockeables van con quantity null, en cambio, los stockeables tienen quantity
export const ProductsMP = {
  PREMIUM: { productId: 57 },
  PDA: { productId: 1003470 },
  NULINGA: { productId: 1003518 },
  MIGURU: { productId: 1003520, quantity: 1 },
  DOCTORCV: { productId: 1003532, quantity: 1 },
}
